<template>
  <a-modal :visible.sync="visible" title="表单分类管理" @cancel="close" :footer="null">
    <a-button type="primary" style="margin-bottom: 10px" @click="openAdd">增加</a-button>
    <a-table :data-source="typeList" rowKey="id" :pagination="false" size="small">
      <a-table-column title="#" data-index="index" :width="45" align="center" fixed="left">
        <template slot-scope="text, record, index">{{ index + 1 }}</template>
      </a-table-column>
      <a-table-column title="表单分类" data-index="name" align="left" />
      <a-table-column title="操作" align="center">
        <template slot-scope="text, record">
          <a-popconfirm placement="bottom" ok-text="删除" cancel-text="取消" @confirm="deleteType(record.id)">
            <template slot="title">
              <p>确认删除？</p>
            </template>
            <span class="hover-line text-red" title="删除">删除</span>
          </a-popconfirm>
        </template>
      </a-table-column>
    </a-table>
    <div style="height: 20px"></div>
    <a-modal :visible.sync="addVisible" title="增加表单分类管理" @ok="addSubmit" @cancel="closeAdd">
      <a-form-model layout="inline" ref="addForm" :model="addForm" :wrapper-col="{ span: 16, offset: 0 }">
        <a-form-model-item label="表单分类名称" prop="name" :rules="[{ required: true, message: '不允许为空', trigger: 'blur' }]">
          <a-input v-model="addForm.name"></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-modal>
</template>
<script>
import { activityTypeAdd, activityTypeDelete, activityTypeList } from '@/api/activity'
export default {
  name: 'type-manage',
  data() {
    return {
      visible: false,
      addVisible: false,
      typeList: [],
      addForm: {},
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    close() {
      this.visible = false
    },
    openAdd() {
      this.addForm = {}
      this.addVisible = true
    },
    closeAdd() {
      this.addVisible = false
    },
    load() {
      activityTypeList().then(res => {
        this.typeList = res.data.result
      })
    },
    addSubmit() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          let param = { ...this.addForm }
          activityTypeAdd(param).then(({ data }) => {
            if (data.success) {
              this.$message.success('保存表单成功')
              this.closeAdd()
              this.load()
              this.parentReloading()
            } else {
              this.$message.error('保存表单失败')
            }
          })
        }
      })
    },
    deleteType(id) {
      activityTypeDelete({ id }).then(({ data }) => {
        if (data.success) {
          this.$message.success('删除成功')
          this.load()
          this.parentReloading()
        } else {
          this.$message.error('删除失败')
        }
      })
    },
    parentReloading() {
      this.$parent.loadActivityTypes()
    },
  },
  mounted() {
    this.load()
  },
}
</script>
<style scoped></style>
